const SCORE_KEY = 'vorakit_tictactoe_scores';
const PREFS_KEY = 'vorakit_tictactoe_prefs';

/** @typedef {{ x: number, o: number, draws: number }} Scores */
/** @typedef {{ sound: boolean, difficulty: 'easy' | 'medium' | 'hard', mode: 'pvp' | 'ai' }} Prefs */

const defaultScores = () => ({ x: 0, o: 0, draws: 0 });

const defaultPrefs = () => ({
  sound: false,
  difficulty: 'medium',
  mode: 'ai',
});

/**
 * @returns {Scores}
 */
export function loadScores() {
  try {
    const raw = localStorage.getItem(SCORE_KEY);
    if (!raw) return defaultScores();
    const p = JSON.parse(raw);
    return {
      x: Number(p.x) || 0,
      o: Number(p.o) || 0,
      draws: Number(p.draws) || 0,
    };
  } catch {
    return defaultScores();
  }
}

/**
 * @param {Scores} scores
 */
export function saveScores(scores) {
  try {
    localStorage.setItem(SCORE_KEY, JSON.stringify(scores));
  } catch {
    /* ignore */
  }
}

/**
 * @returns {Prefs}
 */
export function loadPrefs() {
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    if (!raw) return defaultPrefs();
    const p = JSON.parse(raw);
    const difficulty =
      p.difficulty === 'easy' || p.difficulty === 'medium' || p.difficulty === 'hard'
        ? p.difficulty
        : 'medium';
    const mode = p.mode === 'pvp' || p.mode === 'ai' ? p.mode : 'ai';
    return {
      sound: Boolean(p.sound),
      difficulty,
      mode,
    };
  } catch {
    return defaultPrefs();
  }
}

/**
 * @param {Partial<Prefs>} prefs
 */
export function savePrefs(prefs) {
  try {
    const cur = loadPrefs();
    localStorage.setItem(PREFS_KEY, JSON.stringify({ ...cur, ...prefs }));
  } catch {
    /* ignore */
  }
}
